import {Component, OnInit} from '@angular/core';
import {PlantillaService} from '../service-plantilla/plantilla.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  menus: any = [];

  constructor(
    public _plantilla: PlantillaService,
  ) {
  }

  ngOnInit() {
    this._plantilla.variable = '25px';
    if (localStorage.getItem('accessToken') !== '' && localStorage.getItem('accessToken') !== null && localStorage.getItem('userName') !== '') {
      if (localStorage.getItem('mostrarMenu') === 'true') {
        this.menus = JSON.parse(localStorage.getItem('menu'));
      }
    }
  }

  // toggleNavbar() {
  //   this._plantilla.navbarOpen = !this._plantilla.navbarOpen;
  // }

  closeNav() {
    this._plantilla.variable = '25px';
    this._plantilla.navbarOpen = false;
  }

}
